<template>
  <div>
    <transition name="modal">
      <information-modal
        v-if="showInfoModal"
        :message="info"
        @close="showInfoModal = false"
      ></information-modal>
    </transition>

    <div class="flex items-center space-x-4">
      <h2>{{ isEditing ? "Editar" : "Agregar" }} Evaluación</h2>
    </div>

    <div v-if="!loading" class="card mt-2">
      <form
        v-if="petTypes && selectedType && petCheckupAttributes"
        class="flex flex-col w-full items-center"
        @submit.prevent="save"
      >
        <div class="flex flex-col w-full">
          <label for="weight">Peso (kg)</label>
          <input id="weight" type="number" step="any" v-model="form.weight" />
          <validation-errors :errors="errorFor('weight')"></validation-errors>
        </div>

        <div v-if="!isEditing" class="flex flex-col w-full">
          <div v-if="!frontImage" class="mt-6 mx-auto">
            <input
              class="hidden"
              type="file"
              name="image"
              id="frontImage"
              ref="image"
              accept="image/*"
              @change="handleFrontImage"
            />

            <label for="frontImage" class="secondary-button font-normal"
              >+ Agregar Imagen Frontal (opcional)</label
            >
          </div>

          <div v-else class="mt-6 flex flex-col mx-auto">
            <p class="text-sm font-semibold mx-auto">Imagen Frontal</p>

            <img
              ref="imagePreview"
              class="w-full h-full sm:w-72 sm:h-72 rounded-lg object-contain object-center border border-primary-500"
              :src="frontImagePreview"
            />

            <button
              class="delete-button mt-2 mx-auto"
              @click.prevent="
                frontImage = null;
                frontImagePreview = null;
              "
            >
              Remover
            </button>
          </div>

          <div v-if="!sideImage" class="mt-6 mx-auto">
            <input
              class="hidden"
              type="file"
              name="image"
              id="sideImage"
              ref="image"
              accept="image/*"
              @change="handleSideImage"
            />

            <label for="sideImage" class="secondary-button font-normal"
              >+ Agregar Imagen de Lado (opcional)</label
            >
          </div>

          <div v-else class="mt-6 flex flex-col mx-auto">
            <p class="text-sm font-semibold mx-auto">Imagen de Lado</p>

            <img
              ref="imagePreview"
              class="w-full h-full sm:w-72 sm:h-72 rounded-lg object-contain object-center border border-primary-500"
              :src="sideImagePreview"
            />

            <button
              class="delete-button mt-2 mx-auto"
              @click.prevent="
                sideImage = null;
                sideImagePreview = null;
              "
            >
              Remover
            </button>
          </div>

          <div v-if="!topImage" class="mt-6 mx-auto">
            <input
              class="hidden"
              type="file"
              name="image"
              id="topImage"
              ref="image"
              accept="image/*"
              @change="handleTopImage"
            />

            <label for="topImage" class="secondary-button font-normal"
              >+ Agregar Imagen Superior (opcional)</label
            >
          </div>

          <div v-else class="mt-6 flex flex-col mx-auto">
            <p class="text-sm font-semibold mx-auto">Imagen Superior</p>

            <img
              ref="imagePreview"
              class="w-full h-full sm:w-72 sm:h-72 rounded-lg object-contain object-center border border-primary-500"
              :src="topImagePreview"
            />

            <button
              class="delete-button mt-2 mx-auto"
              @click.prevent="
                topImage = null;
                topImagePreview = null;
              "
            >
              Remover
            </button>
          </div>
        </div>

        <label for="" class="mt-6">Composición corporal actual</label>
        <div class="w-full" v-if="selectedType == 1">
          <div class="card-option-wrapper">
            <div
              v-for="bodyComposition in petCheckupAttributes.dog_body_compositions"
              :key="bodyComposition.id"
              class="mt-2 card-option"
              :class="[
                {
                  'selected-border':
                    form.body_composition_id === bodyComposition.id,
                },
              ]"
              @click.stop.prevent="
                selectOption('body_composition_id', bodyComposition.id)
              "
            >
              <p class="text-xs">#{{ bodyComposition.reference }}</p>
              <p class="text-xs font-medium">{{ bodyComposition.value }}</p>
              <img
                class="sm:max-w-[200px] my-2"
                :src="
                  require('@/assets/pets/dog_' +
                    bodyComposition.reference +
                    '.png')
                "
                alt=""
              />
              <button
                class="text-xs underline mt-2"
                @click.prevent="openInfoModal(bodyComposition.description)"
              >
                Detalle
              </button>
            </div>
          </div>
        </div>

        <div class="w-full" v-else-if="selectedType == 2">
          <div class="card-option-wrapper">
            <div
              v-for="bodyComposition in petCheckupAttributes.cat_body_compositions"
              :key="bodyComposition.id"
              class="mt-2 card-option"
              :class="[
                {
                  'selected-border':
                    form.body_composition_id === bodyComposition.id,
                },
              ]"
              @click.stop.prevent="
                selectOption('body_composition_id', bodyComposition.id)
              "
            >
              <p class="text-xs">#{{ bodyComposition.reference }}</p>
              <p class="text-xs font-medium">{{ bodyComposition.value }}</p>
              <img
                class="sm:max-w-[200px] my-2"
                :src="
                  require('@/assets/pets/cat_' +
                    bodyComposition.reference +
                    '.png')
                "
                alt=""
              />
              <button
                class="text-xs underline mt-2"
                @click.prevent="openInfoModal(bodyComposition.description)"
              >
                Detalle
              </button>
            </div>
          </div>
        </div>
        <validation-errors
          :errors="errorFor('body_composition_id')"
        ></validation-errors>

        <label for="" class="mt-6">Actividad actual</label>
        <div class="card-option-wrapper w-full">
          <div
            v-for="activityLevel in petCheckupAttributes.activity_levels"
            :key="activityLevel.id"
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': form.activity_level_id === activityLevel.id,
              },
            ]"
            @click.stop.prevent="
              selectOption('activity_level_id', activityLevel.id)
            "
          >
            <p class="text-xs font-medium">{{ activityLevel.value }}</p>

            <img
              class="sm:w-[200px] h-[200px] my-2 object-contain"
              :src="
                require('@/assets/pets/' +
                  (selectedType == 1 ? 'dog_' : 'cat_') +
                  'activity_' +
                  activityLevel.id +
                  '.png')
              "
              alt=""
            />

            <button
              class="text-xs underline mt-2"
              @click.prevent="openInfoModal(activityLevel.description)"
            >
              Detalle
            </button>
          </div>
        </div>
        <validation-errors
          :errors="errorFor('activity_level_id')"
        ></validation-errors>

        <label for="" class="mt-6"
          >Al momento de comer, ¿cómo es su actitud?</label
        >
        <div class="card-option-wrapper w-full">
          <div
            v-for="eatingAttitude in petCheckupAttributes.eating_attitudes"
            :key="eatingAttitude.id"
            class="mt-2 card-option"
            :class="[
              {
                'selected-border':
                  form.eating_attitude_id === eatingAttitude.id,
              },
            ]"
            @click.stop.prevent="
              selectOption('eating_attitude_id', eatingAttitude.id)
            "
          >
            <p class="text-xs font-medium">{{ eatingAttitude.value }}</p>

            <img
              class="sm:w-[200px] h-[200px] my-2 object-contain"
              :src="
                require('@/assets/pets/eating_' + eatingAttitude.id + '.png')
              "
              alt=""
            />
          </div>
        </div>
        <validation-errors
          :errors="errorFor('eating_attitude_id')"
        ></validation-errors>

        <label for="" class="mt-6">Actualmente, ¿qué come?</label>
        <div class="card-option-wrapper w-full">
          <div
            v-for="foodType in petCheckupAttributes.food_types"
            :key="foodType.id"
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': form.food_type_id === foodType.id,
              },
            ]"
            @click.stop.prevent="selectOption('food_type_id', foodType.id)"
          >
            <p class="text-xs font-medium">{{ foodType.value }}</p>

            <img
              class="sm:w-[200px] h-[200px] my-2 object-contain"
              :src="require('@/assets/pets/food_' + foodType.id + '.png')"
              alt=""
            />
          </div>
        </div>
        <validation-errors
          :errors="errorFor('food_type_id')"
        ></validation-errors>

        <div class="flex flex-col w-full mt-6">
          <label for="food_brand">¿Qué marca?</label>
          <input id="food_brand" type="text" v-model="form.food_brand" />
          <validation-errors
            :errors="errorFor('food_brand')"
          ></validation-errors>
        </div>

        <label for="" class="mt-6">¿Tiene alguna alergia alimentaria?</label>

        <div class="card-option-wrapper w-full">
          <div
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': hasFoodAllergies === false,
              },
            ]"
            @click.stop.prevent="selectHasFoodAllergies(false)"
          >
            <p class="text-xs font-medium">No</p>
          </div>

          <div
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': hasFoodAllergies === true,
              },
            ]"
            @click.stop.prevent="selectHasFoodAllergies(true)"
          >
            <p class="text-xs font-medium">Sí</p>
          </div>
        </div>
        <validation-errors
          :errors="errorFor('has_food_allergies')"
        ></validation-errors>

        <label v-if="hasFoodAllergies" for="" class="mt-6"
          >Selecciona todas las que apliquen</label
        >

        <div v-if="hasFoodAllergies" class="card-option-wrapper w-full">
          <div
            v-for="(foodAllergy, index) in petCheckupAttributes.food_allergies"
            :key="index"
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': form.food_allergies.includes(foodAllergy.id),
              },
            ]"
            @click.stop.prevent="
              selectMultipleOption('food_allergies', foodAllergy.id)
            "
          >
            <p class="font-medium text-xs">{{ foodAllergy.value }}</p>
          </div>
        </div>
        <div v-if="hasFoodAllergies" class="flex flex-col w-full mt-2">
          <label for="other_food_allergy">Otra</label>
          <input
            id="other_food_allergy"
            type="text"
            v-model="form.other_food_allergy"
          />
        </div>

        <label v-if="hasFoodAllergies && !isEditing" for="" class="mt-6"
          >¿Realizaste algún examen de alérgenos?</label
        >

        <div
          v-if="hasFoodAllergies && !isEditing"
          class="card-option-wrapper w-full"
        >
          <div
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': hasAllergiesTest === false,
              },
            ]"
            @click.stop.prevent="selectHasAllergiesTest(false)"
          >
            <p class="text-xs font-medium">No</p>
          </div>

          <div
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': hasAllergiesTest === true,
              },
            ]"
            @click.stop.prevent="selectHasAllergiesTest(true)"
          >
            <p class="text-xs font-medium">Sí</p>
          </div>
        </div>
        <validation-errors
          :errors="errorFor('has_allergies_test')"
        ></validation-errors>

        <div v-if="hasAllergiesTest && !isEditing">
          <div class="mt-6 mx-auto">
            <input
              class="hidden"
              type="file"
              name="file"
              id="allergy_test"
              ref="file"
              accept="application/pdf"
              @change="handleAllergiesTestFiles"
            />

            <label
              for="allergy_test"
              class="secondary-button font-normal mx-auto"
            >
              + Agregar Archivo PDF
            </label>
          </div>

          <div
            v-for="(file, index) in allergiesTestFiles"
            :key="index"
            class="mt-6 flex flex-col"
          >
            <p class="text-sm mx-auto">{{ file.name }}</p>
            <button
              class="delete-button mx-auto"
              @click.prevent="allergiesTestFiles.splice(index, 1)"
            >
              Remover
            </button>
          </div>
        </div>

        <label for="" class="mt-6">¿Tiene algún problema de salud?</label>

        <div class="card-option-wrapper w-full">
          <div
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': hasDiseases === false,
              },
            ]"
            @click.stop.prevent="selectHasDiseases(false)"
          >
            <p class="text-xs font-medium">No</p>
          </div>

          <div
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': hasDiseases === true,
              },
            ]"
            @click.stop.prevent="selectHasDiseases(true)"
          >
            <p class="text-xs font-medium">Sí</p>
          </div>
        </div>

        <validation-errors
          :errors="errorFor('has_diseases')"
        ></validation-errors>

        <label v-if="hasDiseases" for="" class="mt-6"
          >Selecciona todos los que apliquen</label
        >

        <div v-if="hasDiseases" class="card-option-wrapper w-full">
          <div
            v-for="(disease, index) in petCheckupAttributes.diseases"
            :key="index"
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': form.diseases.includes(disease.id),
              },
            ]"
            @click.stop.prevent="selectMultipleOption('diseases', disease.id)"
          >
            <p class="font-medium text-xs">{{ disease.value }}</p>
          </div>
        </div>
        <div v-if="hasDiseases" class="flex flex-col w-full mt-2">
          <label for="other_disease">Otro</label>
          <input id="other_disease" type="text" v-model="form.other_disease" />
        </div>

        <label v-if="hasDiseases && !isEditing" for="" class="mt-6"
          >¿Realizaste algún examen de salud?</label
        >

        <div
          v-if="hasDiseases && !isEditing"
          class="card-option-wrapper w-full"
        >
          <div
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': hasDiseasesTest === false,
              },
            ]"
            @click.stop.prevent="selectHasDiseasesTest(false)"
          >
            <p class="text-xs font-medium">No</p>
          </div>

          <div
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': hasDiseasesTest === true,
              },
            ]"
            @click.stop.prevent="selectHasDiseasesTest(true)"
          >
            <p class="text-xs font-medium">Sí</p>
          </div>
        </div>
        <validation-errors
          :errors="errorFor('has_diseases_test')"
        ></validation-errors>

        <div v-if="hasDiseasesTest && !isEditing">
          <div class="mt-6 mx-auto">
            <input
              class="hidden"
              type="file"
              name="file"
              id="disease_test"
              ref="file"
              accept="application/pdf"
              @change="handleDiseasesTestFiles"
            />

            <label
              for="disease_test"
              class="secondary-button font-normal mx-auto"
              >+ Agregar Archivo PDF</label
            >
          </div>

          <div
            v-for="(file, index) in diseasesTestFiles"
            :key="index"
            class="mt-6 flex flex-col"
          >
            <p class="text-sm mx-auto">{{ file.name }}</p>
            <button
              class="delete-button mx-auto"
              @click.prevent="diseasesTestFiles.splice(index, 1)"
            >
              Remover
            </button>
          </div>
        </div>

        <label for="snacks" class="mt-6"
          >¿Acostumbras a ofrecer premios, snacks o sobras de alimentos?</label
        >
        <div class="card-option-wrapper w-full">
          <div
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': form.has_snacks === false,
              },
            ]"
            @click.stop.prevent="selectHasSnacks(false)"
          >
            <p class="text-xs font-medium">No</p>
          </div>

          <div
            class="mt-2 card-option"
            :class="[
              {
                'selected-border': form.has_snacks === true,
              },
            ]"
            @click.stop.prevent="selectHasSnacks(true)"
          >
            <p class="text-xs font-medium">Sí</p>
          </div>
        </div>
        <validation-errors :errors="errorFor('has_snacks')"></validation-errors>

        <div class="flex flex-col w-full mt-6">
          <label for="additional_comments">Comentarios adicionales</label>
          <textarea
            class="h-28"
            id="additional_comments"
            type="text"
            v-model="form.additional_comments"
          />
        </div>

        <div class="flex flex-col w-full mt-6">
          <label for="specialist_comments">Comentarios del especialista</label>
          <textarea
            class="h-28"
            id="specialist_comments"
            type="text"
            v-model="form.specialist_comments"
          />
        </div>

        <primary-button type="submit" class="mt-10 mx-0" :loading="loadingForm"
          >{{ isEditing ? "Guardar" : "Agregar" }}
        </primary-button>
      </form>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import InformationModal from "@/components/ui/InformationModal";
import validationErrors from "@/mixins/validationErrors";
import deleteMixin from "@/mixins/deleteMixin";
import { is422 } from "@/utils/response";
export default {
  name: "Pet Checkup Form",

  components: {
    InformationModal,
  },

  data() {
    return {
      selectedType: null,
      petTypes: null,
      petCheckupAttributes: null,
      form: {
        weight: "",
        body_composition_id: null,
        activity_level_id: null,
        eating_attitude_id: null,
        food_type_id: null,
        food_brand: "",
        food_allergies: [],
        other_food_allergy: "",
        has_allergies_test: false,
        diseases: [],
        other_disease: "",
        has_snacks: null,
        additional_comments: "",
        specialist_comments: "",
      },
      loading: false,
      loadingForm: false,
      isEditing: false,
      showInfoModal: false,
      info: null,
      hasFoodAllergies: null,
      hasAllergiesTest: null,
      hasDiseases: null,
      hasDiseasesTest: null,
      frontImage: null,
      frontImagePreview: null,
      sideImage: null,
      sideImagePreview: null,
      topImage: null,
      topImagePreview: null,
      allergiesTestFiles: [],
      diseasesTestFiles: [],
    };
  },

  computed: {
    breeds() {
      return this.selectedType
        ? this.petTypes.filter((type) => type.id === this.selectedType)[0]
            .breeds
        : null;
    },
  },

  created() {
    this.$store.commit("setSelectedTab", "pets");

    this.selectedType = this.$route.params.selectedType;

    if (this.$route.params.id) {
      this.isEditing = true;
      this.loadCheckup();
    }

    this.loadPetTypes();
    this.loadPetCheckupAttributes();
  },

  mixins: [validationErrors, deleteMixin],

  methods: {
    async loadPetTypes() {
      try {
        this.petTypes = await api.resources.getPetTypes();
      } catch (error) {}
    },

    async loadPetCheckupAttributes() {
      this.loading = true;

      try {
        this.petCheckupAttributes =
          await api.resources.getPetCheckupAttributes();
      } catch (error) {}

      this.loading = false;
    },

    async loadCheckup() {
      this.loading = true;

      try {
        let checkup = await api.pets.getCheckupById(this.$route.params.id);

        checkup.body_composition_id = checkup.body_composition.id;
        checkup.activity_level_id = checkup.activity_level.id;
        checkup.eating_attitude_id = checkup.eating_attitude.id;
        checkup.food_type_id = checkup.food_type.id;
        checkup.food_brand = checkup.food_brand;

        let foodAllergies = checkup.pet_checkup_attributes.filter(
          (att) => att.type === "food_allergy"
        );
        checkup.food_allergies = foodAllergies.map((att) => att.id);
        this.hasFoodAllergies =
          foodAllergies.length > 0 || checkup.other_food_allergy ? true : false;

        let diseases = checkup.pet_checkup_attributes.filter(
          (att) => att.type === "disease"
        );
        checkup.diseases = diseases.map((att) => att.id);
        this.hasDiseases =
          diseases.length > 0 || checkup.other_disease ? true : false;

        this.hasAllergiesTest = checkup.has_allergies_test;

        delete checkup.pet;

        this.form = await JSON.parse(JSON.stringify(checkup));
      } catch (error) {
        console.log(error);
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    getPetTypeOptions() {
      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      this.petTypes.forEach((petType) => {
        options.push({
          value: petType.id,
          label: petType.name,
        });
      });

      return options;
    },

    getBreedOptions() {
      if (!this.breeds) {
        return [];
      }

      const options = [{ value: null, label: "Seleccionar", disabled: false }];

      this.breeds.forEach((breed) => {
        options.push({
          value: breed.id,
          label: breed.name,
        });
      });

      return options;
    },

    openInfoModal(text) {
      this.info = text;
      this.showInfoModal = true;
    },

    selectOption(key, value) {
      this.form[key] = this.form[key] === value ? null : value;
    },

    selectMultipleOption(key, id) {
      if (this.form[key].includes(id)) {
        this.form[key] = this.form[key].filter((v) => v !== id);
      } else {
        this.form[key].push(id);
      }
    },

    handleFrontImage(e) {
      let image = e.target.files[0];

      if (image && image.size > 25 * 1024 * 1024) {
        this.$store.dispatch(
          "errorSnack",
          "La imagen excede el tamaño máximo de 25mb."
        );
        return;
      }

      if (image) {
        let url = URL.createObjectURL(image);
        let img = new Image();

        img.onload = () => {
          URL.revokeObjectURL(url);
          let reader = new FileReader();
          reader.onload = (e) => {
            this.frontImage = image;
            this.frontImagePreview = e.target.result;
          };
          reader.readAsDataURL(image);
        };

        img.onerror = () => {
          URL.revokeObjectURL(url);
          alert("Unable to load image");
        };

        img.src = url;
      }
    },

    handleSideImage(e) {
      let image = e.target.files[0];

      if (image && image.size > 25 * 1024 * 1024) {
        this.$store.dispatch(
          "errorSnack",
          "La imagen excede el tamaño máximo de 25mb."
        );
        return;
      }

      if (image) {
        let url = URL.createObjectURL(image);
        let img = new Image();

        img.onload = () => {
          URL.revokeObjectURL(url);
          let reader = new FileReader();
          reader.onload = (e) => {
            this.sideImage = image;
            this.sideImagePreview = e.target.result;
          };
          reader.readAsDataURL(image);
        };

        img.onerror = () => {
          URL.revokeObjectURL(url);
          alert("Unable to load image");
        };

        img.src = url;
      }
    },

    handleTopImage(e) {
      let image = e.target.files[0];

      if (image && image.size > 25 * 1024 * 1024) {
        this.$store.dispatch(
          "errorSnack",
          "La imagen excede el tamaño máximo de 25mb."
        );
        return;
      }

      if (image) {
        let url = URL.createObjectURL(image);
        let img = new Image();

        img.onload = () => {
          URL.revokeObjectURL(url);
          let reader = new FileReader();
          reader.onload = (e) => {
            this.topImage = image;
            this.topImagePreview = e.target.result;
          };
          reader.readAsDataURL(image);
        };

        img.onerror = () => {
          URL.revokeObjectURL(url);
          alert("Unable to load image");
        };

        img.src = url;
      }
    },

    handleAllergiesTestFiles(e) {
      const file = e.target.files[0];

      if (file && file.size > 25 * 1024 * 1024) {
        this.$store;
        e.target.value = "";
        return;
      }

      if (file) {
        const url = URL.createObjectURL(file);

        if (file.type === "application/pdf") {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.allergiesTestFiles.push({
              file: file,
              name: file.name,
            });
          };
          reader.readAsArrayBuffer(file);
        } else {
          console.error("Unsupported file type:", file.type);
        }
      }
    },

    handleDiseasesTestFiles(e) {
      const file = e.target.files[0];

      if (file && file.size > 25 * 1024 * 1024) {
        this.$store;
        e.target.value = "";
        return;
      }

      if (file) {
        const url = URL.createObjectURL(file);

        if (file.type === "application/pdf") {
          const reader = new FileReader();
          reader.onload = (e) => {
            this.diseasesTestFiles.push({
              file: file,
              name: file.name,
            });
          };
          reader.readAsArrayBuffer(file);
        } else {
          console.error("Unsupported file type:", file.type);
        }
      }
    },

    selectHasFoodAllergies(value) {
      this.hasAllergiesTest = null;
      this.allergiesTestFiles = [];

      if (this.hasFoodAllergies === value) {
        this.hasFoodAllergies = null;
        this.form.food_allergies = [];
        this.form.other_food_allergy = "";
      } else {
        this.hasFoodAllergies = value;
        if (value === false) {
          this.form.food_allergies = [];
          this.form.other_food_allergy = "";
        }
      }
    },

    selectHasAllergiesTest(value) {
      this.hasAllergiesTest = null;
      this.allergiesTestFiles = [];

      if (this.hasAllergiesTest === value) {
        this.hasAllergiesTest = false;
      } else {
        this.hasAllergiesTest = value;
      }
    },

    selectHasDiseases(value) {
      this.hasDiseasesTest = null;
      this.diseasesTestFiles = [];

      if (this.hasDiseases === value) {
        this.hasDiseases = null;
        this.form.diseases = [];
        this.form.other_disease = "";
      } else {
        this.hasDiseases = value;
        if (value === false) {
          this.form.diseases = [];
          this.form.other_disease = "";
        }
      }
    },

    selectHasDiseasesTest(value) {
      this.hasDiseasesTest = null;
      this.diseasesTestFiles = [];

      if (this.hasDiseasesTest === value) {
        this.hasDiseasesTest = false;
      } else {
        this.hasDiseasesTest = value;
      }
    },

    selectHasSnacks(value) {
      if (this.form.has_snacks === value) {
        this.form.has_snacks = null;
      } else {
        this.form.has_snacks = value;
      }
    },

    save() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      if (!this.isEditing) {
        this.createPetCheckup();
      } else {
        this.updatePetCheckup();
      }
    },

    validateForm() {
      this.errors = {};

      if (!this.form.weight) {
        this.errors["weight"] = ["Campo requerido"];
      }

      if (!this.form.body_composition_id) {
        this.errors["body_composition_id"] = ["Campo requerido"];
      }

      if (!this.form.activity_level_id) {
        this.errors["activity_level_id"] = ["Campo requerido"];
      }

      if (!this.form.eating_attitude_id) {
        this.errors["eating_attitude_id"] = ["Campo requerido"];
      }

      if (!this.form.food_type_id) {
        this.errors["food_type_id"] = ["Campo requerido"];
      }

      if (this.hasFoodAllergies === null) {
        this.errors["has_food_allergies"] = ["Campo requerido"];
      }

      if (this.hasDiseases === null) {
        this.errors["has_diseases"] = ["Campo requerido"];
      }

      if (
        this.hasFoodAllergies &&
        this.form.food_allergies.length === 0 &&
        !this.form.other_food_allergy
      ) {
        this.errors["has_food_allergies"] = [
          "Debes agregar al menos una opción",
        ];
      }

      if (
        this.hasDiseases &&
        this.form.diseases.length === 0 &&
        !this.form.other_disease
      ) {
        this.errors["has_diseases"] = ["Debes agregar al menos una opción"];
      }

      if (this.form.has_snacks === null) {
        this.errors["has_snacks"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async createPetCheckup() {
      this.loadingForm = true;

      const formData = new FormData();

      formData.append("form", JSON.stringify(this.form));
      formData.append("frontImage", this.frontImage);
      formData.append("sideImage", this.sideImage);
      formData.append("topImage", this.topImage);

      this.allergiesTestFiles.forEach((item, index) => {
        formData.append(`allergiesTestFiles[${index}]`, item.file);
      });

      this.diseasesTestFiles.forEach((item, index) => {
        formData.append(`diseasesTestFiles[${index}]`, item.file);
      });

      try {
        const response = await api.pets.createCheckup(
          this.$route.params.petId,
          formData
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "petsDetail", params: { id: this.$route.params.petId } });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },

    async updatePetCheckup() {
      this.loadingForm = true;

      try {
        const response = await api.pets.updateCheckup(
          this.$route.params.id,
          this.form
        );
        this.$store.dispatch("successSnack", response.message);
        this.$router.push({ name: "petsIndex" });
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingForm = false;
    },
  },

  watch: {
    selectedType() {
      this.form.breed_id = null;
    },
  },
};
</script>